import { AgentSchedule, Logger } from '@nice-ccf/core-sdk';
import { WemScheduleService } from './service/wem-schedule-service';
/**
 * Class to manage all wem-schedule related methods
 */
export class WemSchedule {
  private wemScheduleService = <WemScheduleService>{};
  protected logger: Logger = new Logger('SDK', 'WemSchedule');

  /**
   * get instance for wemScheduleService
   * @example
   * ```
   * this.wemScheduleService = new WemScheduleService();
   * ```
   */
  constructor() {
    this.wemScheduleService = new WemScheduleService();
  }

   /**
   * Get the current logged in agent schedule
   * @param startDate - start date for fetching schedule
   * @param endDate - end date for fetching schedule
   * @returns - It returns the agent schedule
   * ```
   * @example
   * getSchedule(Tue Aug 16 2022 11:49:38 GMT+0530, Tue Aug 17 2022 11:49:38 GMT+0530);
   * ```
   */
  public getSchedule(startDate: Date, endDate: Date): Promise<AgentSchedule[] | any> {
    return new Promise<AgentSchedule[]>((resolve, reject) => {
      if(startDate <= endDate){
      this.wemScheduleService.getSchedule(startDate, endDate).then(
        (response) => {
          resolve(response as AgentSchedule[]);
        },
        (error: any ) => {
          this.logger.error(
            'getSchedule',
            'getSchedule for user failed ' + JSON.stringify(error)
          );
          reject(
            'Data not found'
          );
        }
      );
      }else{
        this.logger.error(
          'getSchedule',
          'endDate should be greater than startDate'
        );
        reject(
          'endDate should be greater than startDate'
        );
      }
    });
  }
}
